import { Grid } from "@mui/material";
import MDTypography from "components/MDTypography";
import PictureAvatar from "components/PictureAvatar";
import moment from "moment";
import AvailabilityRowActions from "./AvailabilityRowActions";

const AvailabilityRow = ({ row, refresh, showImage = true, onDelete, onViewEvents }) => {
  return (
    <>
      <Grid container spacing={3} alignItems="center" flexWrap="nowrap">
        <Grid item flexGrow={1} flexBasis={0} flexShrink={1} overflow="hidden">
          <MDTypography variant="body2">
            {row.firstName} {row.lastName}
          </MDTypography>
        </Grid>
        <Grid item flexGrow={1} flexBasis={0} flexShrink={1} overflow="hidden">
          <MDTypography variant="body2">
            {moment(row.startDate).format("ddd MM/DD/YYYY")}
          </MDTypography>
        </Grid>
        <Grid item flexGrow={1} flexBasis={0} flexShrink={1} overflow="hidden">
          <MDTypography variant="body2">
            {`${moment(row.startDate).format("hh:mm A")}-${moment(row.endDate).format("hh:mm A")}`}
          </MDTypography>
        </Grid>
        <Grid item flexBasis="auto">
          <AvailabilityRowActions row={row} onDelete={onDelete} onViewEvents={onViewEvents} />
        </Grid>
      </Grid>
    </>
  );
};

export default AvailabilityRow;
